import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export function Checkbox({
  checked,
  className,
  description,
  disabled = false,
  label,
  labelClassName = "font-medium text-foreground",
  onCheckedChange,
  testId,
}: {
  checked?: boolean;
  className?: string;
  description?: ReactNode;
  disabled?: boolean;
  label: ReactNode;
  /** Override the default label typography — e.g. for a dark surface. */
  labelClassName?: string;
  onCheckedChange?: (checked: boolean) => void;
  /** `data-testid` on the control itself (a Radix button, role="checkbox"). */
  testId?: string;
}) {
  return (
    <label
      className={cn(
        "flex items-start gap-3",
        description ? "min-h-11" : "min-h-0",
        disabled && "cursor-not-allowed opacity-60",
        className,
      )}
    >
      <CheckboxPrimitive.Root
        checked={checked}
        disabled={disabled}
        className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-[6px] border border-border bg-card text-primary shadow-sm transition-colors data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground disabled:cursor-not-allowed"
        data-slot="interactive-control"
        data-testid={testId}
        onCheckedChange={(value) => onCheckedChange?.(value === true)}
      >
        <CheckboxPrimitive.Indicator>
          <Check className="h-3.5 w-3.5" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <span className={cn(description ? "space-y-1" : "space-y-0")}>
        <span className={cn("block text-sm", labelClassName)}>{label}</span>
        {description ? (
          <span className="block text-sm text-muted-foreground">
            {description}
          </span>
        ) : null}
      </span>
    </label>
  );
}
